module.exports = __webpack_public_path__ + "img/menu_closed_red.a6213a43.svg";